/**
 * Date Utilities for Jainam Seva Setu
 * Always handles dates in the format YYYY-MM-DD (ISO date only)
 */

/**
 * Returns today's date in YYYY-MM-DD format (local time)
 */
export const today = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const normalizeDateOnly = (dateStr) => {
  if (!dateStr) return '';
  return dateStr.includes('T') ? dateStr.slice(0, 10) : dateStr;
};

/**
 * Formats a YYYY-MM-DD string into Indian format DD/MM/YYYY
 */
export const formatDate = (dateStr) => {
  if (!dateStr) return '—';
  const normalized = normalizeDateOnly(dateStr);

  const parts = normalized.split('-');
  if (parts.length !== 3) return normalized;

  const [y, m, d] = parts;
  return `${d}/${m}/${y}`;
};

/**
 * Formats a YYYY-MM-DD string into DD-Mon-YYYY without timezone conversion
 */
export const formatDateShort = (dateStr) => {
  if (!dateStr) return '—';
  const normalized = normalizeDateOnly(dateStr);
  const parts = normalized.split('-');
  if (parts.length !== 3) return normalized;

  const [year, month, day] = parts;
  const monthNames = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];
  const monthLabel = monthNames[parseInt(month, 10) - 1];
  if (!monthLabel) return normalized;

  return `${day}-${monthLabel}-${year}`;
};
